import React from 'react'
import { useTranslation } from "react-i18next";

export function CustomPresetColors({ colors, onSelect }){
    
    const { t, i18n } = useTranslation(["translation"]);
  
    return (
      <div style={{ display: 'flex', flexWrap: 'wrap' }}>
        {colors.map((colorObj, index) => (
          <div
            key={index}
            onClick={() => onSelect(colorObj.color)}
            style={{ flex: '0 0 33.333%', padding: '10px', textAlign: 'center' }}
          >
            <div
              style={{
                backgroundColor: colorObj.color,
                width: '24px',
                height: '24px',
                margin: 'auto'
              }}
            ></div>
            <p>{t(colorObj.title)}</p>
          </div>
        ))}
      </div>
    );
  };
  

export default CustomPresetColors